<template>
    <!-- 遮罩层 -->
    <div class="download-modal-backdrop" v-if="isShow" @click="handleClose"></div>
  
    <!-- 弹窗主体 -->
    <div class="download-modal" v-if="isShow">
      <!-- 关闭按钮 -->
      <!-- <div class="modal-close-btn" @click="handleClose">×</div> -->
      
      <!-- 弹窗内容 -->
      <div class="modal-content">
        <h3 class="modal-title">{{ $t('appDownload.confirm') }}</h3>
        <p class="modal-desc">
            {{ $t('appDownload.prompt') }}
        </p>
      </div>
      
      <!-- 操作按钮 -->
      <div class="modal-btns">
        <button class="btn cancel-btn" @click="handleClose">   {{ $t('appDownload.Cancel') }}</button>
        <button class="btn confirm-btn" @click="handleDownload">   {{ $t('appDownload.download1') }}</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DownloadConfirmModal',
    props: {
      // 父组件控制弹窗显示/隐藏
      isShow: {
        type: Boolean,
        default: false
      },
      // 下载链接（默认使用用户提供的APK地址）
      downloadUrl: {
        type: String,
        default: 'http://zhibo.earningchat.com/matrixpower/app-debug.apk'
      }
    },
    methods: {
      // 关闭弹窗（向父组件发射事件）
      handleClose() {
        this.$emit('close-modal');
      },
  
      // 确认下载：创建临时a标签触发下载
      handleDownload() {
        // 避免直接window.location.href跳转，用a标签触发下载逻辑
        const downloadLink = document.createElement('a');
        downloadLink.href = this.downloadUrl;
        downloadLink.download = 'MatrixPower_app-debug.apk'; // 自定义下载文件名
        
        // 触发点击（部分浏览器需手动触发）
        document.body.appendChild(downloadLink);
        downloadLink.click();
        
        // 移除临时标签，避免DOM冗余
        document.body.removeChild(downloadLink);
        
        // 下载触发后自动关闭弹窗（可选，根据需求调整）
        this.handleClose();
        
        // 提示用户（可选，增强体验）
        alert('下载已启动，若未弹出下载框，请检查浏览器下载设置');
      }
    }
  };
  </script>
  
  <style scoped>
  /* 遮罩层：全屏半透明，统一深色风格 */
  .download-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 999;
    backdrop-filter: blur(2px); /* 背景模糊，提升质感 */
    transition: opacity 0.3s ease;
  }
  
  /* 弹窗主体：垂直水平居中，深色背景 */
  .download-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 420px;
    background-color: #181A20; /* 与此前K线图背景统一 */
    border: 1px solid rgba(52, 152, 219, 0.2);
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    box-sizing: border-box;
    transition: all 0.3s ease;
  }
  
  /* 关闭按钮 */
  .modal-close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 20px;
    height: 20px;
    border: 1px dashed rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .modal-close-btn:hover {
    border-color: rgba(255, 255, 255, 0.6);
    color: #fff;
  }
  
  /* 弹窗内容区 */
  .modal-content {
    margin-bottom: 24px;
    background: #181A20;
  }
  
  .modal-title {
    font-size: 18px;
    color: #FFC107;
    text-align: center;
    margin-bottom: 12px;
    font-weight: 500;
  }
  
  .modal-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.5;
    text-align: center;
  }
  
  /* 按钮容器：横向排列，主次区分 */
  .modal-btns {
    display: flex;
    gap: 12px;
  }
  
  .btn {
    flex: 1;
    height: 44px;
    border: none;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  /* 取消按钮：浅灰，次要操作 */
  .cancel-btn {
    background-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.8);
  }
  
  .cancel-btn:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
  
  /* 确认按钮：黄色，主要操作（与此前技术支持按钮风格统一） */
  .confirm-btn {
    background-color: #FFD200;
    color: #181A20;
  }
  
  .confirm-btn:hover {
    background-color: #FFC107;
  }
  
  /* 响应式适配：小屏幕按钮垂直排列 */
  @media (max-width: 360px) {
    .modal-btns {
      flex-direction: column;
    }
    
    .modal-title {
      font-size: 16px;
    }
    
    .modal-desc {
      font-size: 13px;
    }
  }
  </style>